/**
 * A folder shown only as an icon (design fix 5): always carries the folder's name as `title`,
 * `aria-label` and the prototype's `data-tip` tooltip. Folders have no colour (fix 8): the icon uses the
 * surrounding text colour. Use it in rows, the toolbar, Details, the phone bar and pickers.
 */

import type { Folder } from '@digester/core';
import { Icon } from '../icons/Icon.js';

export interface FolderIconProps {
  folder: Pick<Folder, 'name' | 'icon'> | null | undefined;
  className?: string;
  size?: number;
}

export function FolderIcon({ folder, className, size }: FolderIconProps) {
  const name = folder?.name ?? 'Unknown folder';
  return (
    <Icon
      name={folder?.icon ?? 'folder'}
      size={size}
      title={name}
      className={className ? `folder-icon ${className}` : 'folder-icon'}
      role="img"
      aria-hidden={false}
      aria-label={name}
      data-tip={name}
    />
  );
}
